import GATSBY_COMPILED_MDX from "/opt/build/repo/src/blog/2019-08-01-delta-lake-0-3-0-released/index.mdx";
import {graphql} from "gatsby";
import * as React from "react";
import SEO from "src/components/SEO";
import PageLayout from "src/components/PageLayout";
import CardDataList from "src/components/CardDataList";
import Section from "src/components/Section";
import FilteredPosts from "src/components/FilterPosts";
const BlogCollectionTemplate = ({data, pageContext}) => {
  const [filter, setFilter] = React.useState("");
  const {featuredCount} = pageContext;
  const {edges} = data.allMdx;
  if (!edges.length) {
    return React.createElement("div", null, "No articles found!");
  }
  const cards = edges.map(({node}) => {
    const {frontmatter = {}, fields = {}} = node;
    const {title, description, author, thumbnail} = frontmatter;
    const {slug} = fields;
    return {
      title,
      description,
      url: slug,
      date: " ",
      author,
      thumbnail
    };
  });
  const handleFilter = e => setFilter(e.target.value);
  const normalizedStr = query => query.toLowerCase().includes(filter.toLowerCase());
  const filteredCards = cards.filter(({title}) => normalizedStr(title));
  return React.createElement(PageLayout, null, React.createElement(Section, {
    padding: "xxl",
    title: "Delta Lake Blogs",
    primary: true,
    background: "white"
  }, React.createElement(FilteredPosts, {
    onChange: handleFilter,
    cards: filteredCards
  }), React.createElement(CardDataList, {
    cards: filteredCards,
    showFeatured: featuredCount > 0,
    columns: {
      xs: 1,
      sm: 2,
      lg: 3
    },
    density: "relaxed",
    thumbnailRatio: [16, 9],
    clampDescriptionLines: 2
  })));
};
export const Head = ({pageContext}) => {
  const {currentPage} = pageContext;
  return React.createElement(SEO, {
    title: "Delta Lake Blogs",
    pageIndex: currentPage
  });
};
export const pageQuery = graphql`
  query {
    allMdx(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fields: { pageType: { eq: "blog" } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            description
            author
            thumbnail {
              childImageSharp {
                gatsbyImageData
              }
            }
            date(formatString: "MMMM D, YYYY")
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;
BlogCollectionTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogCollectionTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
